import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { FinanceApplication } from "../../types/Dossier";

export const getFinanceApplication = (
  dossierId: string,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["finance-application", dossierId],
    queryFn: (): Promise<FinanceApplication> => {
      return fetchWithAuth<FinanceApplication>(
        "getFinanceApplication",
        dossierId
      );
    },
    enabled: isQueryEnabled(options),
  });
};
